



























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import AppTextField from '@/components/AppTextField.vue'
import AppPhoneInput from '@/components/AppPhoneInput.vue'
import { IInsuredEmploymentInput } from '@/modules/Insured/interfaces/insured-form'

@Component({
  components: {
    AppTextField,
    AppPhoneInput
  }
})
export default class InsuredFormEmployment extends Vue {
  @Prop({ type: Object as () => IInsuredEmploymentInput }) value!: IInsuredEmploymentInput

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
